'use client';

import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithRef } from 'react';

import s from './Checkbox.module.css';

export interface CheckboxProps extends ComponentPropsWithRef<'input'> {
  ariaDisabled?: boolean;
  className?: string;
  disabled?: boolean;
  id: string;
  isIndeterminate?: boolean;
  name: string;
  value?: string;
}

export const checkboxVariants = cva(s.checkbox, {
  variants: {
    isIndeterminate: {
      true: s.isIndeterminate,
    },
  },
});

export const Checkbox = (props: CheckboxProps) => {
  const {
    ariaDisabled,
    className,
    disabled = false,
    isIndeterminate = false,
    ...attrs
  } = props;

  const appearsDisabled = ariaDisabled || disabled ? true : undefined;

  return (
    <input
      aria-disabled={appearsDisabled}
      className={clsx(
        checkboxVariants({
          isIndeterminate,
          className,
        }),
      )}
      disabled={disabled}
      type="checkbox"
      {...attrs}
    />
  );
};
